(function () {
  // Texte de la petite ligne si le titre d'une collection ne contient aucun chiffre
  var SURTITRE = 'Vasques en pierre';
  var TEXTE_PLUS = 'Voir plus';
  var TEXTE_MOINS = 'Voir moins';
  var TEXTE_LIEN = 'Voir toute la collection';
  var NB_PRODUITS = 4;         // produits visibles au départ dans chaque rayon (et après "Voir moins")
  var RATIO_PHOTO = 100;    // hauteur du cadre photo produit en % de sa largeur (100 = carré)
  var FOND_CARTE = '#f5f4f2'; // fond des cartes produit
  var FOND_BARRE = '#E8DDD4'; // fond de la barre "Voir plus" / "Voir moins"
  var NOM_COULEUR = '#000000';  // couleur du nom du produit et du texte de la barre
  var NOM_POIDS = '500';        // graisse du nom (400 = normal, 500 = medium, 600 = semi gras)
  var PRIX_COULEUR = '#6b6b6b'; // couleur du prix
  var PRIX_POIDS = '400';       // graisse du prix
  var LIEN_COULEUR = '#1a1a1a'; // couleur du lien vers la collection
  var TAILLE_TEXTE = '14px';    // taille du nom et du prix
  var MARGE_TEXTE = '20px';     // marge à gauche et à droite du nom et du prix, dans la carte
  var POSITION_IMAGE_PC = 'center center';      // cadrage de la photo de bannière sur ordinateur
  var POSITION_IMAGE_MOBILE = 'center center';  // cadrage sur mobile, par exemple '70% center'

  // Nombre de produits de la collection de la page (donné par la section) : la grille est construite
  // dès que Globo a affiché tous ses produits ; au bout de DELAI_MAX_GRILLE (ms), on la construit quoi qu'il arrive
  var ATTENDU = parseInt(window.RAYONS_TOTAL, 10) || 0;
  var DELAI_MAX_GRILLE = 1500;

  // Grand titre (la dimension, par exemple 120 cm)
  var TITRE_TAILLE_PC = 'clamp(48px, 5.4vw, 90px)';
  var TITRE_TAILLE_MOBILE = '40px';
  var UNITE_TAILLE = '0.45em';  // taille de "cm" par rapport au chiffre (0.45 = 45 %)

  // Espace entre la petite ligne du haut et le grand titre (ordinateur)
  var SURTITRE_ESPACE_PC = '1.1rem';

  // Petite ligne du haut et accroche, quand le texte est sur la photo (ordinateur)
  var OMBRE_TEXTE = '0 1px 14px rgba(0, 0, 0, 0.35)';
  var ACCROCHE_LARGEUR_PC = '44ch';   // largeur maximale de l'accroche
  var ACCROCHE_INTERLIGNE_PC = '1.7'; // espace entre les lignes de l'accroche
  var ACCROCHE_OPACITE_PC = '0.9';    // 1 = blanc plein, plus bas = plus discret

  // Dégradé sombre en bas de la bannière (pour que le texte se lise sur les photos claires)
  var DEGRADE_BANNIERE = 'linear-gradient(to top, rgba(0,0,0,0.75) 0%, rgba(0,0,0,0.38) 38%, rgba(0,0,0,0) 75%)';

  // Ordinateur : hauteur des bannières, en pourcentage de la hauteur de l'écran (100 = plein écran)
  var HERO_PC_HAUTEUR = 100;
  var HERO_PC_MIN = 600;
  // false = toutes les bannières se chargent en différé (le carrousel s'affiche au dessus de la grille)
  var PREMIERE_BANNIERE_PRIORITAIRE = false;

  // Mobile : le titre et la phrase passent sous la photo, en noir sur fond blanc (false = texte sur la photo)
  var TEXTE_SOUS_IMAGE_MOBILE = true;
  var FOND_TEXTE_MOBILE = '#ffffff';
  var TEXTE_MOBILE_COULEUR = '#333333';
  var HERO_MOBILE_RATIO = 130;
  var HERO_MOBILE_MIN = 440;

  // Pastille "Voir moins" collante : visible pendant qu'un rayon ouvert est à l'écran.
  // Elle se place à droite de "Filtrer", et les deux pastilles sont centrées ensemble.
  var PILULE_MOINS = true;          // false = pas de pastille
  var PILULE_MOINS_ECART = 10;      // espace entre "Filtrer" et "Voir moins", en pixels

  // Bouton flottant "Filtrer", boutons du haut et voile : gérés par le fichier collections-commun.js
  var PILULE_FILTRE = false;
  var MASQUER_BARRE_HAUT = true;
  var TEXTE_PILULE = 'Filtrer';
  var PILULE_POSITION_PC = 'centre';
  var PILULE_POSITION_MOBILE = 'centre';
  var PILULE_BAS_PC = '28px';
  var PILULE_BAS_MOBILE = '20px';
  var PILULE_FOND = '#A88B79';
  var PILULE_TEXTE_COULEUR = '#ffffff';
  var PILULE_OMBRE = '0 4px 12px rgba(120, 90, 75, 0.35)';

  var BOUTONS_EN_HAUT = false;
  var BOUTONS_HAUT_FIXE = true;
  var BOUTONS_HAUT_ECART = 16;

  var VOILE_HAUT = false;
  var VOILE_RGB = '255, 255, 255';
  var VOILE_OPACITE = 0.94;
  var VOILE_DEGRADE = 26;
  var VOILE_APPARITION = 120;

  var donnees = document.getElementById('gammes-data');
  if (!donnees) return;
  var gammes = JSON.parse(donnees.textContent);
  var ordre = {};              // pour chaque collection, la liste des produits dans l'ordre de la collection
  var dispos = {};             // pour chaque rayon, les produits disponibles (après filtres), dans l'ordre
  var ouvertes = {};           // pour chaque rayon, vrai quand il est ouvert en entier
  var table = {};              // adresse du produit, carte d'origine de Globo
  var signatureCourante = '';
  var premierRenduOk = !ATTENDU;   // sans nombre attendu, on construit dès que possible

  // Les listes de produits de chaque rayon sont fournies par la page (aucune lecture au chargement)
  var totalProduits = 0;
  gammes.forEach(function (g) {
    ordre[g.slug] = g.handles || [];
    totalProduits += ordre[g.slug].length;
  });
  var pret = totalProduits > 0;

  var UNITE_VH = (window.CSS && CSS.supports && CSS.supports('height', '1svh')) ? 'svh' : 'vh';

  function log() {
    try { console.log.apply(console, ['[gammes]'].concat(Array.prototype.slice.call(arguments))); } catch (e) {}
  }

  function poser(el, styles) {
    for (var k in styles) {
      if (styles.hasOwnProperty(k)) el.style.setProperty(k, styles[k], 'important');
    }
  }

  function each(selecteur, fn) {
    Array.prototype.forEach.call(document.querySelectorAll(selecteur), fn);
  }

  function revelerListe() {
    document.documentElement.classList.remove('rayons-attente');
  }

  // Apparition et disparition en douceur de la pastille "Voir moins",
  // et glissement en douceur du bouton "Filtrer" quand il lui laisse la place
  function injecterStyles() {
    if (document.getElementById('gamme-styles-moins')) return;
    var s = document.createElement('style');
    s.id = 'gamme-styles-moins';
    s.textContent =
      '.gamme_pilule_moins{display:inline-flex!important;opacity:0!important;visibility:hidden!important;transform:translateY(12px)!important;transition:opacity .25s ease,transform .25s ease,visibility .25s!important}' +
      '.gamme_pilule_moins.est-visible{opacity:1!important;visibility:visible!important;transform:translateY(0)!important}' +
      '.gamme_pilule_moins.est-visible:hover{opacity:.88!important}' +
      '.gamme_pilule_moins:focus-visible{outline:2px solid #fff;outline-offset:-5px}' +
      'html .col_pilule{transition:opacity .25s ease,transform .25s ease,visibility .25s,translate .25s ease!important}';
    document.head.appendChild(s);
  }

  // Coupe le titre d'une collection au premier chiffre :
  // "Vasques en pierre 120 cm" devient la petite ligne "Vasques en pierre" et le grand titre "120 cm"
  function decouperTitre(titre) {
    var t = (titre || '').replace(/\s+/g, ' ').trim();
    var m = t.match(/^(.*?)\s*(\d.*)$/);
    if (m && m[1]) return { sur: m[1], nom: m[2] };
    return { sur: SURTITRE, nom: t };
  }

  // Sépare le chiffre et l'unité du grand titre : "120 cm" devient "120" et "cm"
  function separerUnite(nom) {
    var m = (nom || '').match(/^(\d+(?:[.,]\d+)?)\s*([^\d\s].*)$/);
    if (m) return { valeur: m[1], unite: m[2] };
    return null;
  }

  // Sur téléphone et petite tablette, la page peut être plus large que l'écran si un élément déborde :
  // on prend alors la plus petite des deux largeurs. Sur ordinateur, on garde la largeur de la fenêtre.
  function largeurEcran() {
    var w = window.innerWidth;
    var s = (window.screen && window.screen.width) ? window.screen.width : w;
    if (s <= 900) return Math.min(w, s);
    return w;
  }

  function pleineLargeur(el) {
    var largeur = Math.min(document.documentElement.clientWidth, largeurEcran());
    poser(el, { 'width': largeur + 'px', 'max-width': 'none', 'margin-left': '0px' });
    var gauche = el.getBoundingClientRect().left;
    poser(el, { 'margin-left': (-gauche) + 'px' });
  }

  function nbCol() {
    return largeurEcran() >= 990 ? 4 : 2;
  }

  function relancerImages() {
    try {
      if (window.lazySizes && window.lazySizes.loader) window.lazySizes.loader.checkElems();
    } catch (e) {}
    window.dispatchEvent(new Event('scroll'));
  }

  // ---------- Barre de filtres du thème et bouton flottant ----------

  var boutonFiltre = null;
  var barreFiltre = null;
  var pilule = null;
  var observateur = null;
  var barreObservee = null;
  var barreHorsEcran = true;
  var scrollEnAttente = false;
  var derniereMajLourde = 0;

  function texteNet(el) {
    return (el.textContent || '').replace(/\s+/g, ' ').trim().toLowerCase();
  }

  function estCandidatFiltre(el) {
    if (el.closest && el.closest('.gamme_pilule')) return false;
    if (!el.getClientRects || el.getClientRects().length === 0) return false;
    var t = texteNet(el);
    return t === 'filtrer par' || t === 'filtrer';
  }

  function trouverBoutonFiltre() {
    if (boutonFiltre && document.body.contains(boutonFiltre)) return boutonFiltre;
    boutonFiltre = null;
    var passes = ['button, a, [role="button"], summary, label', 'span, div, p'];
    for (var p = 0; p < passes.length; p++) {
      var candidats = document.querySelectorAll(passes[p]);
      for (var i = 0; i < candidats.length; i++) {
        var c = candidats[i];
        if (!estCandidatFiltre(c)) continue;
        var parent = c;
        var trop = false;
        while (parent && parent !== document.body) {
          var pos = getComputedStyle(parent).position;
          if ((pos === 'fixed' || pos === 'sticky') && parent.getBoundingClientRect().height > window.innerHeight * 0.4) {
            trop = true;
            break;
          }
          parent = parent.parentElement;
        }
        if (trop) continue;
        boutonFiltre = c;
        return boutonFiltre;
      }
    }
    return null;
  }

  function trouverBarreFiltre(bouton) {
    if (barreFiltre && document.body.contains(barreFiltre)) return barreFiltre;
    barreFiltre = null;
    var el = bouton;
    while (el && el !== document.body) {
      var pos = getComputedStyle(el).position;
      if (pos === 'sticky' || pos === 'fixed') {
        barreFiltre = el;
        return barreFiltre;
      }
      el = el.parentElement;
    }
    return null;
  }

  function barreParContenu(bouton) {
    var el = bouton.parentElement;
    while (el && el !== document.body) {
      if (el.querySelector('.gammes, .gamme, .spf-product-card, ul.product-grid')) return null;
      if (el.querySelector('input') && el.querySelector('select')) return el;
      el = el.parentElement;
    }
    return null;
  }

  function contientPanneau(el) {
    var t = texteNet(el);
    return t.indexOf('type de montage') > -1 || t.indexOf('couleur de pierre') > -1;
  }

  function contientProduits(el) {
    return !!el.querySelector('.gammes, .gamme, .spf-product-card, ul.product-grid');
  }

  function cacherVisuellement(el) {
    if (!el || el.getAttribute('data-gamme-cache') === '1') return;
    el.setAttribute('data-gamme-cache', '1');
    poser(el, {
      'position': 'absolute',
      'width': '1px',
      'height': '1px',
      'min-height': '0',
      'margin': '-1px',
      'padding': '0',
      'border': '0',
      'overflow': 'hidden',
      'clip': 'rect(0 0 0 0)',
      'clip-path': 'inset(50%)',
      'white-space': 'nowrap',
      'opacity': '0',
      'pointer-events': 'none'
    });
  }

  function masquerHors(el, bouton) {
    Array.prototype.forEach.call(el.children, function (enfant) {
      if (enfant === bouton) {
        cacherVisuellement(enfant);
      } else if (enfant.contains(bouton)) {
        masquerHors(enfant, bouton);
      } else if (contientPanneau(enfant) || contientProduits(enfant)) {
        // à garder tel quel
      } else {
        cacherVisuellement(enfant);
      }
    });
  }

  function creerIconeFiltre() {
    var svgNS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(svgNS, 'svg');
    svg.setAttribute('width', '16');
    svg.setAttribute('height', '16');
    svg.setAttribute('viewBox', '0 0 16 16');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('aria-hidden', 'true');
    [['M2 4.5 H14'], ['M2 11.5 H14']].forEach(function (d) {
      var p = document.createElementNS(svgNS, 'path');
      p.setAttribute('d', d[0]);
      p.setAttribute('stroke', 'currentColor');
      p.setAttribute('stroke-width', '1.3');
      p.setAttribute('stroke-linecap', 'round');
      svg.appendChild(p);
    });
    [[10, 4.5], [5.5, 11.5]].forEach(function (c) {
      var k = document.createElementNS(svgNS, 'circle');
      k.setAttribute('cx', String(c[0]));
      k.setAttribute('cy', String(c[1]));
      k.setAttribute('r', '1.7');
      k.setAttribute('fill', PILULE_FOND);
      k.setAttribute('stroke', 'currentColor');
      k.setAttribute('stroke-width', '1.3');
      svg.appendChild(k);
    });
    return svg;
  }

  function creerPilule() {
    if (pilule) return pilule;
    pilule = document.createElement('button');
    pilule.type = 'button';
    pilule.className = 'gamme_pilule';
    pilule.setAttribute('aria-label', TEXTE_PILULE);
    pilule.appendChild(creerIconeFiltre());
    var t = document.createElement('span');
    t.textContent = TEXTE_PILULE;
    pilule.appendChild(t);
    pilule.addEventListener('click', function () {
      var b = trouverBoutonFiltre();
      if (b) b.click();
    });
    document.body.appendChild(pilule);
    return pilule;
  }

  function placerPilule() {
    if (!pilule) return;
    var mobile = largeurEcran() < 750;
    var pos = mobile ? PILULE_POSITION_MOBILE : PILULE_POSITION_PC;
    var bas = mobile ? PILULE_BAS_MOBILE : PILULE_BAS_PC;
    var st = {
      'position': 'fixed',
      'z-index': '50',
      'bottom': 'calc(' + bas + ' + env(safe-area-inset-bottom, 0px))',
      'left': 'auto',
      'right': 'auto',
      'margin': '0',
      'width': 'max-content',
      'align-items': 'center',
      'gap': '10px',
      'padding': mobile ? '14px 24px' : '15px 28px',
      'border': '0',
      'border-radius': '999px',
      'background-color': PILULE_FOND,
      'background-image': 'none',
      'color': PILULE_TEXTE_COULEUR,
      '-webkit-text-fill-color': PILULE_TEXTE_COULEUR,
      'font-family': 'inherit',
      'font-size': '15px',
      'font-weight': '500',
      'letter-spacing': '0.05em',
      'line-height': '1',
      'text-transform': 'none',
      'box-shadow': PILULE_OMBRE,
      'cursor': 'pointer'
    };
    if (pos === 'gauche') {
      st['left'] = '24px';
    } else if (pos === 'droite') {
      st['right'] = '24px';
    } else {
      st['left'] = '0';
      st['right'] = '0';
      st['margin-left'] = 'auto';
      st['margin-right'] = 'auto';
    }
    poser(pilule, st);
  }

  function afficherPilule(oui) {
    if (!pilule) return;
    if (oui) {
      pilule.classList.add('est-visible');
    } else {
      pilule.classList.remove('est-visible');
    }
  }

  function zoneProduits() {
    return document.querySelector('.gammes') || document.querySelector('.product-grid-container');
  }

  function grilleVisible() {
    var z = zoneProduits();
    if (!z) return true;
    var r = z.getBoundingClientRect();
    var actions = document.querySelectorAll('.gamme_actions');
    var fin = actions.length ? actions[actions.length - 1].getBoundingClientRect().bottom : r.bottom;
    var hautBouton = pilule ? pilule.getBoundingClientRect().top : window.innerHeight - 100;
    return fin > hautBouton && r.top < window.innerHeight - 80;
  }

  function majPilule() {
    if (!MASQUER_BARRE_HAUT && !observateur && barreFiltre) {
      barreHorsEcran = barreFiltre.getBoundingClientRect().bottom < 0;
    }
    afficherPilule(barreHorsEcran && grilleVisible());
  }

  function surveillerBarre() {
    if (!barreFiltre || barreObservee === barreFiltre) return;
    if (observateur) { try { observateur.disconnect(); } catch (e) {} }
    barreObservee = barreFiltre;
    try {
      observateur = new IntersectionObserver(function (entrees) {
        barreHorsEcran = !entrees[0].isIntersecting;
        majPilule();
      }, { threshold: 0 });
      observateur.observe(barreFiltre);
    } catch (e) {
      observateur = null;
    }
  }

  function majBarre() {
    if (!PILULE_FILTRE) return;
    var bouton = trouverBoutonFiltre();
    if (!bouton) return;
    var barre = trouverBarreFiltre(bouton);

    if (MASQUER_BARRE_HAUT) {
      if (!barre) barre = barreParContenu(bouton);
      if (!barre) {
        cacherVisuellement(bouton);
      } else if (!contientPanneau(barre) && !contientProduits(barre)) {
        cacherVisuellement(barre);
      } else {
        masquerHors(barre, bouton);
      }
      creerPilule();
      placerPilule();
      barreHorsEcran = true;
      majPilule();
      return;
    }

    if (!barre) return;

    poser(barre, {
      'position': 'static',
      'top': 'auto',
      'bottom': 'auto',
      'left': 'auto',
      'right': 'auto',
      'transform': 'none'
    });

    creerPilule();
    placerPilule();
    surveillerBarre();
    majPilule();
  }

  // ---------- Boutons du site : "Savoir-faire" et "Demander un échantillon" ----------

  var conteneursSite = [];
  var derniereRechercheSite = 0;
  var essaisRechercheSite = 0;
  var voileHaut = null;

  function conteneurFixeBas(el) {
    var p = el;
    while (p && p !== document.body) {
      if (p.getAttribute && p.getAttribute('data-gamme-haut') === '1') return p;
      if (getComputedStyle(p).position === 'fixed') {
        var r = p.getBoundingClientRect();
        return (r.top + r.height / 2 > window.innerHeight / 2) ? p : null;
      }
      p = p.parentElement;
    }
    return null;
  }

  function chercherConteneurSite(nom) {
    var passes = ['a, button, [role="button"]', 'span, div, p'];
    for (var p = 0; p < passes.length; p++) {
      var els = document.querySelectorAll(passes[p]);
      for (var i = 0; i < els.length; i++) {
        var el = els[i];
        if (p === 1 && el.childElementCount > 2) continue;
        if (el.closest('.gammes, .gamme_pilule, .spf-product-card')) continue;
        if (texteNet(el) !== nom) continue;
        if (!el.getClientRects || el.getClientRects().length === 0) continue;
        var c = conteneurFixeBas(el);
        if (c) return c;
      }
    }
    return null;
  }

  function boutonsSiteComplets() {
    if (conteneursSite.length >= 2) return true;
    return conteneursSite.some(function (c) {
      var t = texteNet(c);
      return t.indexOf('savoir-faire') > -1 && t.indexOf('chantillon') > -1;
    });
  }

  function retirerVoile() {
    if (voileHaut && voileHaut.parentNode) voileHaut.parentNode.removeChild(voileHaut);
    voileHaut = null;
  }

  function majVoile(basEntete) {
    if (!VOILE_HAUT || !BOUTONS_HAUT_FIXE) { retirerVoile(); return; }
    if (!voileHaut || !document.body.contains(voileHaut)) {
      voileHaut = document.createElement('div');
      voileHaut.className = 'gamme_voile_haut';
      voileHaut.setAttribute('aria-hidden', 'true');
      document.body.appendChild(voileHaut);
    }
    var hBoutons = 0;
    conteneursSite.forEach(function (c) {
      hBoutons = Math.max(hBoutons, c.getBoundingClientRect().height);
    });
    var hauteur = Math.round(BOUTONS_HAUT_ECART + hBoutons + VOILE_DEGRADE);
    var pleine = 'rgba(' + VOILE_RGB + ', ' + VOILE_OPACITE + ')';
    var apparition = VOILE_APPARITION > 0 ? Math.min(1, Math.max(0, window.scrollY / VOILE_APPARITION)) : 1;
    poser(voileHaut, {
      'display': 'block',
      'position': 'fixed',
      'top': Math.round(basEntete) + 'px',
      'left': '0',
      'right': '0',
      'height': 'calc(' + hauteur + 'px + env(safe-area-inset-top, 0px))',
      'z-index': '44',
      'pointer-events': 'none',
      'background': 'linear-gradient(to bottom, ' + pleine + ' 0%, ' + pleine + ' 55%, rgba(' + VOILE_RGB + ', 0) 100%)',
      'opacity': String(apparition),
      'transition': 'opacity 0.2s ease'
    });
  }

  function majBoutons() {
    if (!BOUTONS_EN_HAUT) return;

    conteneursSite = conteneursSite.filter(function (c) { return document.body.contains(c); });

    if (!boutonsSiteComplets() && essaisRechercheSite < 60 && Date.now() - derniereRechercheSite > 500) {
      derniereRechercheSite = Date.now();
      essaisRechercheSite++;
      ['savoir-faire', 'demander un échantillon'].forEach(function (nom) {
        var c = chercherConteneurSite(nom);
        if (c && conteneursSite.indexOf(c) === -1) conteneursSite.push(c);
      });
    }
    if (!conteneursSite.length) return;

    var entete = document.querySelector('#shopify-section-header, header');
    var basEntete = 0;
    if (entete) basEntete = Math.max(0, entete.getBoundingClientRect().bottom);

    conteneursSite.forEach(function (c) {
      c.setAttribute('data-gamme-haut', '1');
      var st = { 'bottom': 'auto', 'z-index': '45', 'transition': 'none' };
      if (BOUTONS_HAUT_FIXE) {
        st['position'] = 'fixed';
        st['top'] = 'calc(' + Math.round(basEntete + BOUTONS_HAUT_ECART) + 'px + env(safe-area-inset-top, 0px))';
      } else {
        st['position'] = 'absolute';
        st['top'] = Math.round(basEntete + window.scrollY + BOUTONS_HAUT_ECART) + 'px';
      }
      poser(c, st);
    });

    majVoile(basEntete);
  }

  function majTout() {
    majBarre();
    majBoutons();
  }

  function surDefilement() {
    if (scrollEnAttente) return;
    scrollEnAttente = true;
    window.requestAnimationFrame(function () {
      scrollEnAttente = false;
      majBoutons();
      majPilule();
      majPiluleMoins();
      var maintenant = Date.now();
      if (maintenant - derniereMajLourde > 1000) {
        derniereMajLourde = maintenant;
        majBarre();
      }
    });
  }

  // Distance à laisser en haut de l'écran pour que le titre d'un rayon ne passe pas sous l'en-tête
  // ni sous les deux boutons fixes du haut
  function decalageHaut() {
    var entete = document.querySelector('#shopify-section-header, header');
    var bas = entete ? Math.max(0, entete.getBoundingClientRect().bottom) : 0;
    var h = 0;
    conteneursSite.forEach(function (c) {
      h = Math.max(h, c.getBoundingClientRect().height);
    });
    if (BOUTONS_EN_HAUT && BOUTONS_HAUT_FIXE && h) return Math.round(bas + BOUTONS_HAUT_ECART + h + 16);
    return Math.round(bas + 90);
  }

  // ---------- Pastille "Voir moins" collante ----------

  var piluleMoins = null;
  var decalageFiltre = 0;   // décalage horizontal actuellement appliqué au bouton "Filtrer", en pixels

  // Le rayon ouvert dont on parcourt les produits, et dont la vraie barre "Voir moins" est encore sous l'écran
  function slugActif() {
    var trouve = null;
    each('.gamme', function (section) {
      if (trouve) return;
      var slug = section.getAttribute('data-slug');
      if (!ouvertes[slug]) return;
      var btn = section.querySelector('.gamme_plus');
      var ul = section.querySelector('.gamme_liste');
      if (!btn || !ul) return;
      var rb = btn.getBoundingClientRect();
      var ru = ul.getBoundingClientRect();
      if (ru.top < window.innerHeight - 100 && rb.top > window.innerHeight - 20) trouve = slug;
    });
    return trouve;
  }

  function creerPiluleMoins() {
    if (piluleMoins) return piluleMoins;
    piluleMoins = document.createElement('button');
    piluleMoins.type = 'button';
    piluleMoins.className = 'gamme_pilule_moins';
    piluleMoins.setAttribute('aria-label', TEXTE_MOINS);
    var t = document.createElement('span');
    t.textContent = TEXTE_MOINS;
    piluleMoins.appendChild(t);
    piluleMoins.appendChild(creerChevron(true));
    piluleMoins.addEventListener('click', function () {
      var s = slugActif();
      if (s) replier(s);
    });
    document.body.appendChild(piluleMoins);
    return piluleMoins;
  }

  // Décale le bouton "Filtrer" vers la gauche (valeur négative) ou le remet au centre (0).
  // On utilise la propriété "translate", qui ne gêne pas son animation d'apparition.
  function decalerFiltre(px) {
    var arrondi = Math.round(px);
    if (arrondi === decalageFiltre) return;
    var f = document.querySelector('.col_pilule');
    if (!f) return;
    decalageFiltre = arrondi;
    f.style.setProperty('translate', arrondi + 'px 0', 'important');
  }

  // "Voir moins" se place à droite de "Filtrer", et les deux pastilles sont centrées ensemble
  // ("Filtrer" glisse vers la gauche). Si même cela ne tient pas, "Voir moins" se met au dessus de "Filtrer".
  function placerPiluleMoins() {
    if (!piluleMoins) return;
    var mobile = largeurEcran() < 750;
    var bas = mobile ? PILULE_BAS_MOBILE : PILULE_BAS_PC;
    var base = 'calc(' + bas + ' + env(safe-area-inset-bottom, 0px))';
    poser(piluleMoins, {
      'position': 'fixed',
      'z-index': '50',
      'bottom': base,
      'left': 'auto',
      'right': 'auto',
      'margin': '0',
      'width': 'max-content',
      'align-items': 'center',
      'gap': '8px',
      'padding': mobile ? '14px 22px' : '15px 26px',
      'border': '0',
      'border-radius': '999px',
      'background-color': PILULE_FOND,
      'background-image': 'none',
      'color': PILULE_TEXTE_COULEUR,
      '-webkit-text-fill-color': PILULE_TEXTE_COULEUR,
      'font-family': 'inherit',
      'font-size': '15px',
      'font-weight': '500',
      'letter-spacing': '0.05em',
      'line-height': '1',
      'text-transform': 'none',
      'box-shadow': PILULE_OMBRE,
      'cursor': 'pointer'
    });

    var vw = document.documentElement.clientWidth;
    var wM = piluleMoins.offsetWidth;
    var f = document.querySelector('.col_pilule');
    var filtreVisible = !!(f && f.classList.contains('est-visible') && f.offsetWidth > 0);

    // "Filtrer" n'est pas à l'écran : "Voir moins" se place seul, au centre
    if (!filtreVisible) {
      decalerFiltre(0);
      poser(piluleMoins, { 'left': Math.round((vw - wM) / 2) + 'px' });
      return;
    }

    var wF = f.offsetWidth;
    var gauche0 = (vw - wF) / 2;   // position naturelle de "Filtrer" (centré)
    var total = wF + PILULE_MOINS_ECART + wM;
    var peutDecaler = !window.CSS || !CSS.supports || CSS.supports('translate', '1px 0');

    // On décale "Filtrer" pour centrer les deux pastilles ensemble
    if (peutDecaler && total <= vw - 24) {
      var decal = -(wM + PILULE_MOINS_ECART) / 2;
      decalerFiltre(decal);
      poser(piluleMoins, { 'left': Math.round(gauche0 + decal + wF + PILULE_MOINS_ECART) + 'px' });
      return;
    }

    // Écran trop étroit : "Voir moins" au dessus de "Filtrer"
    decalerFiltre(0);
    poser(piluleMoins, {
      'bottom': 'calc(' + bas + ' + env(safe-area-inset-bottom, 0px) + 58px)',
      'left': Math.round((vw - wM) / 2) + 'px'
    });
  }

  function majPiluleMoins() {
    if (!PILULE_MOINS) return;
    var s = slugActif();
    if (s) {
      creerPiluleMoins();
      placerPiluleMoins();
      piluleMoins.classList.add('est-visible');
    } else {
      if (piluleMoins) piluleMoins.classList.remove('est-visible');
      decalerFiltre(0);
    }
  }

  // ---------- Cartes produit ----------

  function styleCarte(colonne) {
    poser(colonne, { 'background-color': FOND_CARTE });

    var carte = colonne.querySelector('.spf-product-card');
    if (!carte) return;

    poser(carte, {
      'margin': '0',
      'padding': '0',
      'background-color': FOND_CARTE
    });

    var inner = carte.querySelector('.spf-product-card__inner');
    if (inner) poser(inner, { 'margin': '0', 'padding': '0' });

    var cadre = carte.querySelector('.spf-product-card__image-wrapper');
    if (cadre) poser(cadre, { 'padding-top': RATIO_PHOTO + '%' });

    Array.prototype.forEach.call(carte.children, function (bloc, i) {
      if (i === 0) return;
      poser(bloc, {
        'margin': '0',
        'padding': '14px ' + MARGE_TEXTE + ' 22px ' + MARGE_TEXTE,
        'background-color': FOND_CARTE,
        'color': NOM_COULEUR,
        'font-size': TAILLE_TEXTE
      });

      Array.prototype.forEach.call(bloc.querySelectorAll('a, h1, h2, h3, h4, p, span, div'), function (el) {
        poser(el, {
          'color': NOM_COULEUR,
          'font-size': TAILLE_TEXTE,
          'font-weight': NOM_POIDS,
          'line-height': '1.4',
          'letter-spacing': '0.01em'
        });
      });

      Array.prototype.forEach.call(bloc.querySelectorAll('[class*="price"], [class*="price"] *'), function (el) {
        poser(el, { 'color': PRIX_COULEUR, 'font-size': TAILLE_TEXTE, 'font-weight': PRIX_POIDS });
      });
    });
  }

  function styliser() {
    var w = largeurEcran();
    var mobile = w < 750;
    var sous = mobile && TEXTE_SOUS_IMAGE_MOBILE;
    var largeurPage = Math.min(document.documentElement.clientWidth, w);
    var nbColonnes = nbCol();

    each('.gammes', function (el) {
      poser(el, { 'display': 'block', 'width': '100%' });
    });

    each('.gamme', function (el) {
      poser(el, { 'display': 'block', 'margin-bottom': '5rem' });
    });

    each('.gamme_hero', function (el) {
      var hauteur, minH, maxH;
      if (sous) {
        hauteur = 'auto'; minH = '0'; maxH = 'none';
      } else if (mobile) {
        hauteur = Math.max(HERO_MOBILE_MIN, Math.round(largeurPage * HERO_MOBILE_RATIO / 100)) + 'px'; minH = '0'; maxH = 'none';
      } else {
        hauteur = HERO_PC_HAUTEUR + UNITE_VH; minH = HERO_PC_MIN + 'px'; maxH = '1200px';
      }
      poser(el, {
        'position': 'relative',
        'display': 'block',
        'height': hauteur,
        'min-height': minH,
        'max-height': maxH,
        'overflow': sous ? 'visible' : 'hidden',
        'color': '#ffffff',
        'text-decoration': 'none',
        'background-color': sous ? FOND_TEXTE_MOBILE : '#d9d4cc'
      });
      pleineLargeur(el);
    });

    each('.gamme_hero_image', function (el) {
      var st = {
        'width': '100%',
        'max-width': 'none',
        'max-height': 'none',
        'object-fit': 'cover',
        'object-position': mobile ? POSITION_IMAGE_MOBILE : POSITION_IMAGE_PC,
        'opacity': '1',
        'visibility': 'visible',
        'display': 'block',
        'background-color': '#d9d4cc'
      };
      if (sous) {
        // Mobile, texte sous la photo : la photo s'affiche entière, à son format réel
        st['position'] = 'relative';
        st['top'] = 'auto';
        st['left'] = 'auto';
        st['height'] = 'auto';
        st['aspect-ratio'] = 'auto';
        st['object-fit'] = 'contain';
      } else {
        st['position'] = 'absolute';
        st['top'] = '0';
        st['left'] = '0';
        st['height'] = '100%';
      }
      poser(el, st);
    });

    each('.gamme_hero_voile', function (el) {
      poser(el, {
        'display': sous ? 'none' : 'block',
        'position': 'absolute',
        'top': '0',
        'left': '0',
        'right': '0',
        'bottom': '0',
        'z-index': '1',
        'pointer-events': 'none',
        'background': DEGRADE_BANNIERE
      });
    });

    each('.gamme_hero_texte', function (el) {
      if (sous) {
        poser(el, {
          'position': 'relative',
          'left': 'auto',
          'bottom': 'auto',
          'z-index': '2',
          'box-sizing': 'border-box',
          'width': '100%',
          'max-width': '100%',
          'padding': '22px 20px 30px 20px',
          'background-color': FOND_TEXTE_MOBILE
        });
      } else {
        poser(el, {
          'position': 'absolute',
          'left': '0',
          'bottom': '0',
          'z-index': '2',
          'box-sizing': 'border-box',
          'width': 'auto',
          'max-width': mobile ? '100%' : '52ch',
          'padding': mobile ? '0 1.25rem 1.75rem 1.25rem' : '0 0 clamp(2rem, 3.5vw, 4rem) clamp(2.5rem, 4.5vw, 5rem)',
          'background-color': 'transparent'
        });
      }
    });

    each('.gamme_hero_texte .gamme_titre', function (el) {
      poser(el, {
        'color': sous ? NOM_COULEUR : '#ffffff',
        'margin': sous ? '0 0 0.75rem 0' : '0 0 1rem 0',
        'font-weight': '300'
      });
    });

    each('.gamme_surtitre', function (el) {
      poser(el, {
        'display': 'block',
        'margin-bottom': mobile ? '0.75rem' : SURTITRE_ESPACE_PC,
        'font-size': mobile ? '15px' : 'clamp(14px, 1.15vw, 19px)',
        'font-weight': '400',
        'letter-spacing': '0.2em',
        'text-transform': 'uppercase',
        'color': sous ? PRIX_COULEUR : 'inherit',
        'opacity': sous ? '1' : '0.95',
        'text-shadow': sous ? 'none' : OMBRE_TEXTE
      });
    });

    each('.gamme_nom', function (el) {
      poser(el, {
        'display': 'block',
        'font-size': mobile ? TITRE_TAILLE_MOBILE : TITRE_TAILLE_PC,
        'font-weight': '300',
        'letter-spacing': '0.03em',
        'line-height': '1.05'
      });
    });

    // L'unité (cm) est plus petite que le chiffre, sur la même ligne de base
    each('.gamme_unite', function (el) {
      poser(el, {
        'font-size': UNITE_TAILLE,
        'font-weight': '300',
        'letter-spacing': '0.08em',
        'vertical-align': 'baseline'
      });
    });

    each('.gamme_hero_texte .gamme_texte', function (el) {
      var st = {
        'color': sous ? TEXTE_MOBILE_COULEUR : '#ffffff',
        'margin': '0',
        'font-size': mobile ? '15px' : 'clamp(16px, 1.3vw, 21px)',
        'line-height': '1.6'
      };
      if (!mobile) {
        st['max-width'] = ACCROCHE_LARGEUR_PC;
        st['line-height'] = ACCROCHE_INTERLIGNE_PC;
        st['opacity'] = ACCROCHE_OPACITE_PC;
        st['text-shadow'] = OMBRE_TEXTE;
      }
      poser(el, st);
    });

    each('.gamme_entete', function (el) {
      poser(el, { 'margin-bottom': '1.5rem' });
    });

    each('.gamme_entete .gamme_titre', function (el) {
      poser(el, { 'margin': '0', 'font-weight': '300' });
    });

    each('.gamme_entete .gamme_texte', function (el) {
      poser(el, { 'max-width': '60ch', 'margin': '0.5rem 0 0 0' });
    });

    each('.gamme_liste', function (ul) {
      poser(ul, {
        'display': 'grid',
        'grid-template-columns': 'repeat(' + nbColonnes + ', minmax(0, 1fr))',
        'gap': '0',
        'align-items': 'stretch',
        'list-style': 'none',
        'padding': '0',
        'margin-top': '0',
        'margin-right': '0',
        'margin-bottom': '0'
      });
      pleineLargeur(ul);
      Array.prototype.forEach.call(ul.children, function (c) {
        poser(c, {
          'width': 'auto',
          'max-width': 'none',
          'min-width': '0',
          'flex': 'none',
          'float': 'none',
          'padding': '0',
          'margin': '0'
        });
        styleCarte(c);
      });
    });

    each('.gamme_actions', function (el) {
      poser(el, {
        'display': 'flex',
        'flex-direction': 'column',
        'align-items': 'center',
        'justify-content': 'flex-start',
        'gap': '0',
        'padding': '0',
        'margin-top': '0',
        'margin-right': '0',
        'margin-bottom': '0'
      });
      pleineLargeur(el);
    });

    each('.gamme_plus', function (el) {
      poser(el, {
        'box-sizing': 'border-box',
        'align-items': 'center',
        'justify-content': 'center',
        'gap': '10px',
        'width': '100%',
        'max-width': 'none',
        'height': mobile ? '56px' : '64px',
        'min-height': '0',
        'padding': '0',
        'margin': '0',
        'border': '0',
        'border-top': '1px solid rgba(0,0,0,0.08)',
        'border-radius': '0',
        'background-color': FOND_BARRE,
        'background-image': 'none',
        'color': NOM_COULEUR,
        '-webkit-text-fill-color': NOM_COULEUR,
        'font-family': 'inherit',
        'font-size': mobile ? '12px' : '13px',
        'font-weight': '500',
        'letter-spacing': '0.18em',
        'text-transform': 'uppercase',
        'box-shadow': 'none',
        'cursor': 'pointer'
      });
    });

    each('.gamme_lien', function (el) {
      poser(el, {
        'display': 'inline-block',
        'width': 'auto',
        'max-width': 'none',
        'min-height': '0',
        'margin': '1.75rem 0 0 0',
        'padding': '0',
        'border': '0',
        'border-radius': '0',
        'background': 'none',
        'background-color': 'transparent',
        'background-image': 'none',
        'color': LIEN_COULEUR,
        '-webkit-text-fill-color': LIEN_COULEUR,
        'font-family': 'inherit',
        'font-size': mobile ? '13px' : '14px',
        'font-weight': '400',
        'letter-spacing': '0.04em',
        'text-transform': 'none',
        'text-decoration': 'underline',
        'text-underline-offset': '5px',
        'text-align': 'center',
        'box-shadow': 'none'
      });
    });

    majBoutonsPlus();
    placerPilule();
  }

  function handleDe(colonne) {
    var lien = colonne.querySelector('a[href*="/products/"]');
    if (!lien) return null;
    return lien.getAttribute('href').split('/products/')[1].split('?')[0].split('#')[0];
  }

  // Titre en deux lignes : la petite ligne, puis le grand titre dont l'unité est plus petite.
  // Le texte lu par les moteurs de recherche reste "Vasques en pierre 120 cm".
  function creerTitre(sur, nom) {
    var titre = document.createElement('h2');
    titre.className = 'gamme_titre';

    var surEl = document.createElement('span');
    surEl.className = 'gamme_surtitre';
    surEl.textContent = sur + ' ';

    var nomEl = document.createElement('span');
    nomEl.className = 'gamme_nom';
    var u = separerUnite(nom);
    if (u) {
      nomEl.appendChild(document.createTextNode(u.valeur));
      var uniteEl = document.createElement('span');
      uniteEl.className = 'gamme_unite';
      uniteEl.textContent = ' ' + u.unite;
      nomEl.appendChild(uniteEl);
    } else {
      nomEl.textContent = nom;
    }

    titre.appendChild(surEl);
    titre.appendChild(nomEl);
    return titre;
  }

  // Chevron vers le bas ("Voir plus") ou vers le haut ("Voir moins")
  function creerChevron(versHaut) {
    var svgNS = 'http://www.w3.org/2000/svg';
    var svg = document.createElementNS(svgNS, 'svg');
    svg.setAttribute('width', '12');
    svg.setAttribute('height', '12');
    svg.setAttribute('viewBox', '0 0 12 12');
    svg.setAttribute('fill', 'none');
    svg.setAttribute('aria-hidden', 'true');
    var p = document.createElementNS(svgNS, 'path');
    p.setAttribute('d', versHaut ? 'M2 7.75 L6 3.75 L10 7.75' : 'M2 4.25 L6 8.25 L10 4.25');
    p.setAttribute('stroke', 'currentColor');
    p.setAttribute('stroke-width', '1.3');
    p.setAttribute('stroke-linecap', 'round');
    p.setAttribute('stroke-linejoin', 'round');
    svg.appendChild(p);
    return svg;
  }

  // Le bouton affiche "Voir plus" quand le rayon est replié, "Voir moins" quand il est ouvert en entier
  function remplirBouton(btn, ouvert) {
    var etat = ouvert ? 'moins' : 'plus';
    if (btn.getAttribute('data-etat') === etat) return;
    btn.setAttribute('data-etat', etat);
    btn.setAttribute('aria-expanded', ouvert ? 'true' : 'false');
    while (btn.firstChild) btn.removeChild(btn.firstChild);
    var libelle = document.createElement('span');
    libelle.textContent = ouvert ? TEXTE_MOINS : TEXTE_PLUS;
    btn.appendChild(libelle);
    btn.appendChild(creerChevron(ouvert));
  }

  // Le bouton n'existe que si le rayon contient plus de produits que ceux affichés au départ
  function majBoutonsPlus() {
    each('.gamme', function (section) {
      var slug = section.getAttribute('data-slug');
      var btn = section.querySelector('.gamme_plus');
      if (!btn) return;
      var total = (dispos[slug] || []).length;
      remplirBouton(btn, !!ouvertes[slug]);
      btn.style.setProperty('display', total > NB_PRODUITS ? 'flex' : 'none', 'important');
    });
  }

  // Ouvre le rayon en entier : toutes les cartes du rayon sont ajoutées d'un coup
  function deplier(slug) {
    var section = document.querySelector('.gamme[data-slug="' + slug + '"]');
    if (!section) return;
    var ul = section.querySelector('.gamme_liste');
    var dispo = dispos[slug] || [];
    ouvertes[slug] = true;
    for (var i = ul.children.length; i < dispo.length; i++) {
      var source = table[dispo[i]];
      if (source) ul.appendChild(source.cloneNode(true));
    }
    styliser();
    relancerImages();
    majPiluleMoins();
    setTimeout(function () { relancerImages(); majPiluleMoins(); }, 200);
  }

  // Ramène le rayon à ses produits de départ, puis remonte l'écran au titre du rayon
  function replier(slug) {
    var section = document.querySelector('.gamme[data-slug="' + slug + '"]');
    if (!section) return;
    var ul = section.querySelector('.gamme_liste');
    var dispo = dispos[slug] || [];
    var cible = Math.min(NB_PRODUITS, dispo.length);
    ouvertes[slug] = false;
    while (ul.children.length > cible) ul.removeChild(ul.lastChild);
    styliser();
    relancerImages();
    majPiluleMoins();
    var haut = section.getBoundingClientRect().top + window.pageYOffset - decalageHaut();
    haut = Math.max(0, haut);
    try {
      window.scrollTo({ top: haut, behavior: 'smooth' });
    } catch (e) {
      window.scrollTo(0, haut);
    }
    setTimeout(function () { relancerImages(); majPiluleMoins(); }, 300);
  }

  function basculer(slug) {
    if (ouvertes[slug]) {
      replier(slug);
    } else {
      deplier(slug);
    }
  }

  function creerSection(g, rang) {
    // Le titre de la collection est coupé au premier chiffre (sauf si un nom d'affichage est fourni)
    var d = g.label ? { sur: SURTITRE, nom: g.label } : decouperTitre(g.title);
    var nom = d.nom;
    var section = document.createElement('section');
    section.className = 'gamme';
    section.setAttribute('data-slug', g.slug);

    var titre = creerTitre(d.sur, d.nom);

    var texte = null;
    if (g.text) {
      texte = document.createElement('p');
      texte.className = 'gamme_texte';
      texte.textContent = g.text;
    }

    if (g.image) {
      var hero = document.createElement('div');
      hero.className = 'gamme_hero';

      var img = document.createElement('img');
      img.className = 'gamme_hero_image';
      img.alt = g.alt || g.title || nom;
      img.decoding = 'async';
      if (g.image_s && g.image_m) {
        img.srcset = g.image_s + ' 900w, ' + g.image_m + ' 1400w, ' + g.image + ' 2000w';
        img.sizes = '100vw';
        img.src = g.image_m;
      } else {
        img.src = g.image;
      }
      if (rang === 0 && PREMIERE_BANNIERE_PRIORITAIRE) {
        img.loading = 'eager';
        img.setAttribute('fetchpriority', 'high');
      } else {
        img.loading = 'lazy';
      }

      var voile = document.createElement('span');
      voile.className = 'gamme_hero_voile';

      var bloc = document.createElement('div');
      bloc.className = 'gamme_hero_texte';
      bloc.appendChild(titre);
      if (texte) bloc.appendChild(texte);

      hero.appendChild(img);
      hero.appendChild(voile);
      hero.appendChild(bloc);
      section.appendChild(hero);
    } else {
      var entete = document.createElement('header');
      entete.className = 'gamme_entete';
      entete.appendChild(titre);
      if (texte) entete.appendChild(texte);
      section.appendChild(entete);
    }

    var ul = document.createElement('ul');
    ul.className = 'gamme_liste';

    var actions = document.createElement('div');
    actions.className = 'gamme_actions';

    // Un seul bouton par rayon : "Voir plus" ouvre tout, puis devient "Voir moins"
    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'gamme_plus';
    remplirBouton(btn, false);
    btn.style.setProperty('display', 'none', 'important');
    btn.addEventListener('click', function () { basculer(g.slug); });
    actions.appendChild(btn);

    // Lien vers la collection complète, avec son titre entier comme texte
    var lien = document.createElement('a');
    lien.className = 'gamme_lien';
    lien.href = g.url;
    lien.appendChild(document.createTextNode(TEXTE_LIEN + ' ' + (g.title || nom)));
    var fleche = document.createElement('span');
    fleche.setAttribute('aria-hidden', 'true');
    fleche.textContent = ' \u2192';
    lien.appendChild(fleche);
    actions.appendChild(lien);

    section.appendChild(ul);
    section.appendChild(actions);
    return { section: section, ul: ul };
  }

  // Construit les rayons à partir des cartes que Globo affiche (donc filtrées) :
  // pour chaque rayon, les produits de la collection dans l'ordre de la collection.
  // Une carte est copiée dans chaque rayon où elle se trouve.
  function faire(force) {
    if (!pret) return;
    var conteneur = document.querySelector('.product-grid-container');
    if (!conteneur) return;
    var liste = conteneur.querySelector('ul.product-grid:not(.gamme_liste)');
    if (!liste) return;

    var ancien = conteneur.querySelector('.gammes');
    var nouvelleTable = {};
    var handles = [];
    Array.prototype.forEach.call(liste.children, function (c) {
      if (!c.querySelector('.spf-product-card')) return;
      var h = handleDe(c);
      if (h && !nouvelleTable.hasOwnProperty(h)) { nouvelleTable[h] = c; handles.push(h); }
    });

    // Premier rendu : on attend que Globo ait affiché tous ses produits (la grille d'origine n'en contient que 16)
    if (!premierRenduOk) {
      if (handles.length < ATTENDU) return;
      premierRenduOk = true;
    }

    // Aucun produit affiché (filtres sans résultat) : on retire les rayons
    if (!handles.length) {
      if (ancien) ancien.parentNode.removeChild(ancien);
      signatureCourante = '';
      majPiluleMoins();
      return;
    }

    // Même liste qu'au dernier passage : rien à refaire (évite les boucles)
    var signature = handles.join('|');
    if (!force && ancien && signature === signatureCourante) return;

    table = nouvelleTable;

    var wrap = document.createElement('div');
    wrap.className = 'gammes';
    var rang = 0;

    gammes.forEach(function (g) {
      var disponibles = (ordre[g.slug] || []).filter(function (h) { return table.hasOwnProperty(h); });
      dispos[g.slug] = disponibles;
      if (!disponibles.length) return;
      var s = creerSection(g, rang);
      rang++;
      // Un rayon ouvert reste ouvert quand les filtres changent
      var n = ouvertes[g.slug] ? disponibles.length : Math.min(NB_PRODUITS, disponibles.length);
      disponibles.slice(0, n).forEach(function (h) {
        s.ul.appendChild(table[h].cloneNode(true));
      });
      wrap.appendChild(s.section);
    });

    if (!wrap.children.length) {
      log('aucun rayon construit : la liste d\'origine reste affichée');
      document.documentElement.classList.remove('rayons-actifs');
      revelerListe();
      return;
    }

    if (ancien) ancien.parentNode.removeChild(ancien);
    liste.parentNode.insertBefore(wrap, liste);
    signatureCourante = signature;
    document.documentElement.classList.add('rayons-actifs');
    revelerListe();

    log(wrap.children.length + ' rayon(s) affiché(s) | ' + handles.length + ' produit(s) sur ' + (ATTENDU || '?') + ' attendus | largeur écran ' + largeurEcran() + 'px');
    styliser();
    majTout();
    majPiluleMoins();
    relancerImages();
    setTimeout(function () { styliser(); majTout(); majPiluleMoins(); relancerImages(); }, 300);
  }

  function regrouper(force) {
    try { faire(force); } catch (e) { console.error('[gammes] erreur', e); }
  }

  window.regrouperGammes = function () { regrouper(true); };

  window.addEventListener('globoFilterRenderCompleted', function () { regrouper(true); majTout(); });
  window.addEventListener('resize', function () { styliser(); majTout(); majPiluleMoins(); });
  window.addEventListener('orientationchange', function () { setTimeout(function () { styliser(); majTout(); majPiluleMoins(); }, 250); });
  window.addEventListener('load', function () { styliser(); majTout(); majPiluleMoins(); });
  window.addEventListener('scroll', surDefilement, { passive: true });

  var minuteur = null;
  function planifier() {
    clearTimeout(minuteur);
    minuteur = setTimeout(function () { regrouper(false); majTout(); }, 120);
  }

  function demarrer() {
    injecterStyles();

    // Sécurité : au bout de ce délai, les rayons sont construits avec ce que Globo a affiché,
    // et la liste d'origine est rendue visible si rien n'a pu être construit
    setTimeout(function () {
      premierRenduOk = true;
      regrouper(false);
      majTout();
      revelerListe();
    }, DELAI_MAX_GRILLE);

    if (pret) {
      log('rayons fournis par la page : ' + gammes.map(function (g) { return g.slug + ' ' + (ordre[g.slug] || []).length; }).join(' | '));
    } else {
      log('aucune liste de produits fournie : la liste d\'origine reste affichée');
      revelerListe();
    }

    regrouper(false);
    majTout();

    var cible = document.querySelector('.product-grid-container') || document.body;
    try {
      new MutationObserver(planifier).observe(cible, { childList: true, subtree: true });
    } catch (e) { log('observateur indisponible', e); }
    var essais = 0;
    var sonde = setInterval(function () {
      regrouper(false);
      majTout();
      essais++;
      if (essais >= 8) clearInterval(sonde);
    }, 1000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', demarrer);
  } else {
    demarrer();
  }
})();